import React from "react";
import {
  FaArrowRight,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaPhoneAlt,
  FaTelegramPlane,
} from "react-icons/fa";
import { Fade } from "react-reveal";
import { Link } from "react-router-dom";

const Footer = () => {
  const navItems = [
    { label: "Курси", to: "/courses" },
    { label: "Новини", to: "/news" },
    { label: "Партнерам", to: "/start#partners" },
    { label: "Вакансії", to: "/vacancies" },
    { label: "МОЖУ!", to: "/moju" },
    { label: "Консультації", to: "/consultations" },
    { label: "Хто ми", to: "/about" },
  ];

  const contacts = [
    "+38 (067) 474-71-71",
    "+38 (095) 658-71-71",
    "+38 (063) 303-55-05",
  ];

  return (
    <footer className="footer relative overflow-hidden bg-white pt-10">
      <div className="container mx-auto px-4">
        <div className="relative z-10 -mb-12 overflow-hidden rounded-[30px] border-2 border-black bg-[#ffd400] px-5 py-7 shadow-[8px_8px_0_#000] md:px-8 lg:px-10">
          <div className="pointer-events-none absolute -right-8 -top-8 h-28 w-28 rounded-[28px] border-2 border-black bg-white/35 rotate-12" />
          <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
            <Fade bottom>
              <div>
                <p className="text-xs font-black uppercase tracking-[0.18em] text-black/65">
                  Yellow Hub
                </p>
                <h2 className="mt-2 text-[30px] font-black uppercase leading-none tracking-[-0.055em] text-black sm:text-[42px]">
                  Почни свій розвиток сьогодні
                </h2>
              </div>
            </Fade>
            <Fade bottom>
              <Link
                to="/registerr"
                className="inline-flex w-fit items-center gap-3 rounded-full border-2 border-black bg-white px-6 py-3 text-sm font-black uppercase text-black shadow-[5px_5px_0_#000] transition hover:-translate-y-0.5 hover:bg-black hover:text-white"
              >
                Реєстрація
                <FaArrowRight />
              </Link>
            </Fade>
          </div>
        </div>
      </div>

      <div className="bg-[#080808] pt-24 text-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-12 gap-8 pb-10 md:gap-10">
            <div className="col-span-12 lg:col-span-5">
              <Fade bottom>
                <Link to="/start" className="inline-flex">
                  <img
                    className="w-[230px] sm:w-[270px]"
                    src="/assets/Images/logo_black_pl.png"
                    alt="Yellow Hub Харків - Єловхаб"
                  />
                </Link>
              </Fade>

              <Fade bottom>
                <p className="mt-5 max-w-[520px] text-[15px] font-semibold leading-7 text-white/68">
                  Сучасний простір розвитку, де знання поєднуються з
                  практикою, підтримкою, активностями та живою спільнотою.
                </p>
              </Fade>

              <Fade bottom>
                <p className="mt-3 max-w-[540px] text-[12px] font-semibold leading-5 text-white/42">
                  Yellow Hub у Харкові також шукають як Єловхаб, Єлов Хаб,
                  Еллоу Хаб або YellowHub. Програма МОЖУ Харків.
                </p>
              </Fade>

              <Fade bottom>
                <div className="mt-6 flex gap-3">
                  <a
                    href="https://www.facebook.com/profile.php?id=61569011374941"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex h-12 w-12 items-center justify-center rounded-2xl border-2 border-white/15 bg-white/8 text-white transition hover:-translate-y-0.5 hover:border-[#ffd400] hover:bg-[#ffd400] hover:text-black"
                    aria-label="Facebook"
                  >
                    <FaFacebookF />
                  </a>
                  <a
                    href="https://www.instagram.com/yellow__hub?igsh=MWVoY3FlNWNqaTRiMQ=="
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex h-12 w-12 items-center justify-center rounded-2xl border-2 border-white/15 bg-white/8 text-white transition hover:-translate-y-0.5 hover:border-[#ffd400] hover:bg-[#ffd400] hover:text-black"
                    aria-label="Instagram"
                  >
                    <FaInstagram />
                  </a>
                  <a
                    href="https://t.me/yellowhubkursy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex h-12 w-12 items-center justify-center rounded-2xl border-2 border-white/15 bg-white/8 text-white transition hover:-translate-y-0.5 hover:border-[#ffd400] hover:bg-[#ffd400] hover:text-black"
                    aria-label="Telegram"
                  >
                    <FaTelegramPlane />
                  </a>
                </div>
              </Fade>
            </div>

            <div className="col-span-12 sm:col-span-6 lg:col-span-3">
              <Fade bottom>
                <h3 className="text-sm font-black uppercase tracking-[0.18em] text-[#ffd400]">
                  Навігація
                </h3>
              </Fade>
              <ul className="mt-5 space-y-3">
                {navItems.map((item) => (
                  <Fade bottom key={item.to}>
                    <li>
                      <Link
                        to={item.to}
                        className="group inline-flex items-center gap-2 text-sm font-black uppercase text-white/76 transition hover:text-[#ffd400]"
                      >
                        <span className="h-1.5 w-1.5 rounded-full bg-[#ffd400] opacity-70 transition group-hover:opacity-100" />
                        {item.label === "МОЖУ!" ? (
                          <span className="notranslate" translate="no">
                            МОЖУ!
                          </span>
                        ) : (
                          item.label
                        )}
                      </Link>
                    </li>
                  </Fade>
                ))}
              </ul>
            </div>

            <div className="col-span-12 sm:col-span-6 lg:col-span-4">
              <Fade bottom>
                <h3 className="text-sm font-black uppercase tracking-[0.18em] text-[#ffd400]">
                  Зв'язок з нами
                </h3>
              </Fade>
              <ul className="mt-5 space-y-3">
                {contacts.map((phone) => (
                  <Fade bottom key={phone}>
                    <li className="flex items-center gap-3 text-sm font-semibold text-white/76">
                      <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-[#ffd400] text-black">
                        <FaPhoneAlt />
                      </span>
                      <span>{phone}</span>
                    </li>
                  </Fade>
                ))}
                <Fade bottom>
                  <li className="flex items-center gap-3 text-sm font-semibold text-white/76">
                    <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-[#ffd400] text-black">
                      <FaEnvelope />
                    </span>
                    <span>yellowhub2024@gmail.com</span>
                  </li>
                </Fade>
                <Fade bottom>
                  <li className="flex items-center gap-3 text-sm font-semibold text-white/76">
                    <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-[#ffd400] text-black">
                      <FaTelegramPlane />
                    </span>
                    <a
                      href="https://t.me/Prostir_YellowHub"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="transition hover:text-[#ffd400]"
                    >
                      @Prostir_YellowHub — служба підтримки
                    </a>
                  </li>
                </Fade>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 py-5">
            <Fade bottom>
              <div className="flex flex-col gap-2 text-xs font-semibold text-white/45 sm:flex-row sm:items-center sm:justify-between">
                <p>© 2026 YellowHub. Всі права захищені.</p>
                <p>Освіта • розвиток • спільнота</p>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
